import type { CollectionSchema } from '@next-space/fe-api-idl';
import { BlockType, CollectionSchemaType, CollectionViewType } from '@next-space/fe-api-idl';
import { useCallback } from 'react';
import { updateBlock } from 'src/redux/managers/block/update';
import * as CollectionViewManager from 'src/redux/managers/collection-view';
import { TocType } from 'src/views/main/aside/toc/types';
import { v4 as uuidV4 } from 'uuid';

import { useCreateDocPage } from '../page';
import { getCurrentSpace } from '../space';
import { useTransaction } from '../use-transaction';
import { composeFormViewFormat, composeTableViewFormat } from './use-add-collection-view';
import { getGroupOptions } from './use-create-property';

export const useAddCollectionForm = () => {
  const createDocPage = useCreateDocPage();
  const transition = useTransaction();

  return useCallback(
    (params?: { success?: (collectionId: string) => void }) => {
      transition(() => {
        const collectionId = createDocPage(
          BlockType.COLLECTION_VIEW_PAGE,
          { parentId: getCurrentSpace().uuid },
          TocType.PRIVATE
        );
        if (!collectionId) return;

        const newSelectPropertyId = uuidV4();
        const options: CollectionSchema['options'] = getGroupOptions();

        const schema = {
          title: {
            name: '标题',
            type: CollectionSchemaType.TITLE,
          },
          [newSelectPropertyId]: {
            name: '分类',
            type: CollectionSchemaType.SELECT,
            options,
          },
        };

        updateBlock(collectionId, { data: { schema } });

        // 构造 format
        const initProperties = [
          { property: 'title', visible: true },
          {
            property: newSelectPropertyId,
            visible: true,
          },
        ];

        CollectionViewManager.add(
          {
            title: '默认视图',
            format: composeFormViewFormat({ formProperties: initProperties }),
            pageSort: [],
            type: CollectionViewType.FORM,
          },
          { parentId: collectionId }
        );

        CollectionViewManager.add(
          {
            title: '表格',
            format: composeTableViewFormat({ tableProperties: initProperties }),
            pageSort: [],
            type: CollectionViewType.TABLE,
          },
          { parentId: collectionId }
        );

        params?.success?.(collectionId);
      });
    },
    [createDocPage, transition]
  );
};
